const headerHP = document.querySelector('.wp-block-colisee-header-hp');

if (headerHP) {
  const bigWord = headerHP.querySelector('.header-hp__big-word');
  var svg = bigWord.querySelector('svg');
  var rect = svg.getBoundingClientRect();

  // Get the witdh of the SVG and set it to the .big-word div (oldest parent)
  bigWord.setAttribute("style","height:" + rect.height + "px");
}